import { formatPrice } from "../../common-deprecated/Globalize";
import {
    type FormatMonthlyPriceType,
    type CommonMonthlyFinanceInfoLabelKey,
    CommonMonthlyPriceLabelKey,
    formatMonthlyPrice,
} from "../../common-deprecated/priceUtils";
import type { CommonSettingsType } from "../../common-deprecated/settings/fetchCommonSettings";
import type { CommonFinanceInfoType, PriceType } from "../../common-deprecated/types/CommonTypes";

export const monthlyPriceFormatting = (
    priceExclPromo: string,
    priceFormat: string,
    financeInfo: CommonFinanceInfoType,
): Partial<Record<CommonMonthlyPriceLabelKey, string>> =>
    financeInfo.productType === "Leasing" && priceFormat.includes("[leasingPrice]")
        ? {
              [CommonMonthlyPriceLabelKey.LeasingPrice]: priceExclPromo,
              [CommonMonthlyPriceLabelKey.Price]: "",
          }
        : {
              [CommonMonthlyPriceLabelKey.Price]: priceExclPromo,
              [CommonMonthlyPriceLabelKey.LeasingPrice]: "",
          };

/**
 * Formats financing monthly prices, ideally this should not be used for anything else (like insurance in the past)
 */
export const formatMonthlyFinancePrice = (
    price: PriceType,
    financeInfo: CommonFinanceInfoType,
    commonSettings: CommonSettingsType,
    priceFormat: string,
    rateWithoutPromotions?: number,
): FormatMonthlyPriceType => {
    const term = financeInfo.term || financeInfo.duration || "";
    const tan = financeInfo.annualInterestRate || financeInfo.interestRate;

    const financeInfoReplacements: Record<CommonMonthlyFinanceInfoLabelKey, string> = {
        term,
        productName: financeInfo.productName || "",
        taeg: financeInfo.effectiveInterestRate || "",
        tan: tan || "",
        // residualValue and downPayment are price values, so apply formatPrice as well.
        residualValue: financeInfo.residualValue
            ? formatPrice(financeInfo.residualValue, commonSettings.culture.name, true)
            : "",
        downPayment: financeInfo.downPayment
            ? formatPrice(financeInfo.downPayment, commonSettings.culture.name, true)
            : "",
        totalAmountFinanced: financeInfo.totalAmountFinanced
            ? formatPrice(financeInfo.totalAmountFinanced, commonSettings.culture.name, true)
            : "",
        amountFinanced: financeInfo.amountFinanced
            ? formatPrice(financeInfo.amountFinanced, commonSettings.culture.name, true)
            : "",
        totalCreditWithFees: financeInfo.totalCreditCostWithFee
            ? formatPrice(financeInfo.totalCreditCostWithFee, commonSettings.culture.name, true)
            : "",
        mileage: financeInfo.mileage || "",
        lastInstalment: financeInfo.lastInstalment || "",
        installments: financeInfo.installments || "",
        disclaimer: "", // This is supported for USC components but not for NC for now.
    };

    return formatMonthlyPrice(
        price.monthly,
        financeInfo,
        commonSettings,
        priceFormat,
        financeInfoReplacements,
        (priceExclPromo: string) => monthlyPriceFormatting(priceExclPromo, priceFormat, financeInfo),
        rateWithoutPromotions,
    );
};
